<template>    
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">                
                <div class="card mb-5">
                    <div class="card-header p-3 pt-2">
                        <div class="icon icon-lg icon-shape shadow text-center border-radius-xl mt-n4 position-absolute bg-gradient-success shadow-dark">
                            <i class="material-symbols-rounded opacity-10 text-white" aria-hidden="true">church</i>
                        </div>
                        <h6 class="mb-2" style="margin-left: 4.5rem !important;">{{ $t('death.Deaths') }}</h6>
                        <div class="row" style="margin-top: -30px;">
                            <div class="col-lg-6">
                            </div>
                            <div class="col-lg-6 d-flex justify-content-end align-items-center gap-2">
                                <div class="btn-group" v-if="userRoleName == 'AssociationAdmin' || userRoleName == 'Keeper' ">
                                    <router-link
                                        :to="associationId ? { name: 'New Death', params: { id: associationId } } : ''"
                                        class="btn btn-sm bg-gradient-success text-nowrap"
                                        :class="{ disabled: !associationId }"
                                        style="width: 150px;"
                                        >
                                    {{ $t('death.Add_death') }}
                                    </router-link>
                                </div>
                                <div class="btn-group" v-if="userRoleName === 'Admin'">
                                    <router-link
                                        class="btn btn-sm bg-gradient-success text-nowrap"                                        
                                        :to="associationId ? `/death/create/${associationId}` : '#'"
                                        :class="{ disabled: !associationId }"
                                        style="width: 150px;"
                                    >
                                        {{ $t('death.Add_death') }}
                                    </router-link>

                                    <!-- Dropdown toggle -->
                                    <button type="button" class="btn btn-sm bg-gradient-success dropdown-toggle dropdown-toggle-split"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    <span class="visually-hidden">{{ $t('settings.Select_association') }}</span>
                                    </button>

                                    <!-- Dropdown menu -->
                                    <ul class="dropdown-menu dropdown-menu-end  custom-association-dropdown">
                                        <li @click="associationId = ''">
                                            <span class="dropdown-item text-muted">
                                            {{ $t('settings.Select_association') }}
                                            </span>
                                        </li>
                                        <li><hr class="dropdown-divider" /></li>
                                        <li
                                            v-for="item in associations"
                                            :key="item.id"
                                            @click="associationId = item.id"
                                            class="dropdown-item"
                                        >
                                            {{ item.abbreviation }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">                                                
                        <table id="death-list" class="table table-flush" v-if="tableVisible" >
                            <thead class="thead-light">
                                <tr>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('death.Animal_details') }}</p></th>                                    
                                </tr>
                            </thead>                            
                            <tbody>
                                <template v-for="(group, groupIndex) in groupedDeaths" :key="groupIndex">
                                    <tr>
                                         <td colspan="9" class="bg-light text-muted small py-2">
                                            <div class="d-flex justify-content-between align-items-center w-100">
                                                <span>
                                                   {{ $t('death.Group') }} {{ groupIndex + 1 }} | {{ $t('death.Death_from_UBN') }}: {{ group[0].departureFromUBN }} | {{ $t('death.Destructor') }}: {{ group[0].departureToLocationName }} | {{ $t('death.Date_of_death') }}: {{ formatDate(group[0].occurrenceDate) }}
                                                </span>
                                                <div v-if="userRoleName != 'Keeper'">
                                                    <!-- Edit Group -->
                                                    <button style="margin-bottom: 0px !important;" :data-id="group[0].movementGroupId" class="btn btn-sm bg-gradient-success me-2 edit-button" :title="$t('common.Edit')">
                                                        <i class="material-symbols-rounded text-white" style="font-size: 0.8rem;">edit</i>
                                                    </button>                                                    
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-for="item in group" :key="item.id">
                                        <td class="text-sm font-weight-normal">                                            
                                            <div class="d-flex justify-content-between align-items-center">
                                                <span v-html="displayText(item)"></span>
                                                <!-- Rollback -->
                                                 <button
                                                    v-if="userRoleName !== 'Keeper'"                                                    
                                                    :data-id="item.id"
                                                    :data-animalubn="item.departureFromUBN"
                                                    :data-departuretoanimalubn="item.departureToUBN"
                                                    :data-animaltagnumber="item.animalTagNumber"
                                                    :data-animalid="item.animalId"  
                                                    :data-departurefromkeeperrvorelationnumber="item.departureFromKeeperRVORelationNumber"
                                                    :data-departuretokeeperrvorelationnumber="item.departureToKeeperRVORelationNumber"
                                                    class="btn btn-sm bg-gradient-warning rollback-button mb-0"
                                                    :title="$t('common.Rollback')">

                                                    <i class="material-symbols-rounded text-white"
                                                    style="font-size: 0.8rem;">
                                                        undo
                                                    </i>
                                                </button>                                                
                                            </div>
                                        </td>
                                        <td></td>                                        
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>                    
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import axios from 'axios';
import { nextTick } from 'vue';
import { DataTable } from "simple-datatables";

export default {
    name: 'Death_index_page',
    components: {
    },
    data() {
        return {
            associationId: '',
            associations: [],
            deaths: [],
            gets: [],            
            dataTableInstance: null,
            tableVisible: false,
            choicesInstanceAssociation: null
        }
    },
    async mounted() {
        try {
            this.$store.commit('setShowLoading', true);            
            await this.loadDeaths();

        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
            this.$store.commit('setShowLoading', false);
        }
    },
    methods: { 
        displayText(f) {
            let parts = [];

            if (f.animalStudbookNumber) parts.push(f.animalStudbookNumber);
            if (f.animalNumber) parts.push(f.animalNumber);
            if (f.animalName) parts.push(`(${f.animalName})`);
            if (f.animalArrivalDate) {
                parts.push(`<span style="color: green">${f.animalArrivalDate}</span>`);
            }
            if (f.breedCode) parts.push(`(${f.breedCode})`);
            return parts.join(' | ');
        },
        async initDataTable() {

            await nextTick();

            const table = document.querySelector("#death-list");
            if (!table || !table.parentNode) {
                console.warn("Table or its parent not found. Skipping DataTable init.");
                return;
            }

            if (this.dataTableInstance) {
                this.dataTableInstance.destroy();
                this.dataTableInstance = null;
            }

            this.dataTableInstance = new DataTable("#death-list", {
                searchable: true,
                fixedHeight: false,
                perPageSelect: false,
                //perPage: 1, // Set the default number of records per page
                //perPageSelect: [5, 10, 20, 50], // Adds a dropdown with options
                columns: [
                    { select: 0, sortable: true },                                                         
                ],
                labels: {
                    search: this.$t('datatable.Search'),
                    perPage: this.$t('datatable.PerPage'),
                    noRows: this.$t('datatable.NoRows'),
                    info: "Tonen {start} t/m {end} van {rows} items",
                    placeholder: this.$t('common.Search') 
                }
            });  

            table.addEventListener('click', this.handleTableClick);
        },  
        handleTableClick(event) {
            
            const targetElement = event.target.closest('[data-id]');
            if (!targetElement) return;

            const id = targetElement.getAttribute('data-id');
            if (!id) return;

            if (event.target.closest('.edit-button')) {
                if (event.target.closest('tr').querySelector('td[colspan]')) {                                    
                    this.$router.push({ name: 'Edit Death', params: { id: id }, query: { type: 'group' } });
                } else {
                    this.$router.push({ name: 'Edit Death', params: { id: id }, query: { type: 'single' } });
                }       
            } else if (event.target.classList.contains('delete-button')) {
                if (event.target.closest('tr').querySelector('td[colspan]')) {                                        
                    this.deleteGroup(id);
                } else {                                        
                    this.deleteDeathModal(id);
                }
            }  else if (event.target.closest('.rollback-button')) {

                const rollbackButton = event.target.closest('.rollback-button');
                
                const id = rollbackButton.getAttribute('data-id');
                const animalUbn = rollbackButton.getAttribute('data-animalubn');
                const departureToAnimalUbn = rollbackButton.getAttribute('data-departuretoanimalubn');
                const animalTagNumber = rollbackButton.getAttribute('data-animaltagnumber');
                const animalId = rollbackButton.getAttribute('data-animalid');
                const departureFromKeeperRVORelationNumber = rollbackButton.getAttribute('data-departurefromkeeperrvorelationnumber');
                const departureToKeeperRVORelationNumber = rollbackButton.getAttribute('data-departuretokeeperrvorelationnumber');

                this.rollbackDeath(
                    id,
                    animalUbn,
                    departureToAnimalUbn,
                    animalTagNumber,
                    animalId,
                    departureFromKeeperRVORelationNumber,
                    departureToKeeperRVORelationNumber
                );
            }
        },
        async loadDeaths() {
            try {

                let response;
                
                const role = this.$store.state.roleName;
                const keeperLocationId = this.$store.state.keeperLocationId;
                const keeperAssociationId = this.$store.state.keeperAssociationId;
                const associationAdminAssociationId = this.$store.state.associationAdminAssociationId;

                let associationId = this.$route.query.associationId
                let ubnId = this.$route.query.ubnId

                if (role === 'Keeper' && keeperLocationId && keeperAssociationId) {
                    ubnId = keeperLocationId;
                    associationId = keeperAssociationId;

                    this.ubnId = ubnId;
                    this.associationId = associationId;
                }

                if (role === 'AssociationAdmin') {                
                    associationId = associationAdminAssociationId;                
                    this.associationId = associationId;
                }

                if (role === 'Admin') {
                    await this.fetchAllAssociationData();
                    response = await axios.get("/death/getall");
                } else if (role === 'AssociationAdmin') {                    
                    response = await axios.get(`/death/getbyassociationubn?associationId=${associationId}&ubnId=`);
                } else if (role === 'Keeper' && ubnId) {
                    response = await axios.get(`/death/getbyassociationubn?associationId=${associationId}&ubnId=${ubnId}`);
                } else {
                    // Optional: handle case where Keeper has no location selected
                    console.warn('No location assigned for Keeper');
                    return;
                }

                this.gets = response.data;

                if (!this.gets?.success) {
                    this.$showError('errors.Contact_system_admin');
                    return;
                }

                const rawData = Array.isArray(this.gets.data) ? this.gets.data : [];

                // 1. Destroy DataTable if it exists
                if (this.dataTableInstance) {
                    this.dataTableInstance.destroy();
                    this.dataTableInstance = null;
                }

                // 2. Force table unmount
                this.tableVisible = false;

                // 3. Wait for DOM update to unmount table
                await this.$nextTick();

                // 4. Set deaths data
                this.deaths = rawData;

                // 5. Force table mount
                this.tableVisible = true;

                // 6. Wait for DOM update to mount table
                await this.$nextTick();

                // 7. Init DataTable if data is present
                if (rawData.length > 0) {
                    this.initDataTable();
                } else {
                    this.initDataTable();
                    this.$showSuccess(this.$t('errors.No_deaths_found'));
                }

            } catch (e) {
                console.error("Exception occurred in loadDeaths()", e);
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${'errors.Contact_system_admin'}: ${errorMessage}`);
            }
        },
        async rollbackDeath(
            id,
            animalUbn,
            departureToAnimalUbn,
            animalTagNumber,
            animalId,
            departureFromKeeperRVORelationNumber,
            departureToKeeperRVORelationNumber) {

            if (!id) {
                this.$showError(
                    this.$t('errors.Record_id_is_missing')
                );
                return;
            }

            const result = await this.$swal.fire({
                text: this.$t('common.Are_you_sure_to_rollback_this_record'),
                cancelButtonText: this.$t('common.Cancel'),
                confirmButtonText: this.$t('common.Confirm_Rollback'),
                showCancelButton: true,
                position: 'top-end'
            });

            if (!result.isConfirmed) {
                return;
            }

            // Create cancel source BEFORE syncRvo()
            const cancelSource = axios.CancelToken.source();

            try {

                this.$store.commit(
                    "rvoSync/START_SYNC",
                    cancelSource
                );

                this.$store.commit(
                    'setShowLoading',
                    true
                );

                // RVO sync
                const rvoResult = await this.syncRvo(
                    id,
                    animalUbn,
                    departureToAnimalUbn,
                    animalTagNumber,
                    animalId,
                    departureFromKeeperRVORelationNumber,
                    departureToKeeperRVORelationNumber,
                    cancelSource
                );

                // RVO failed - show error and stop
                if (!rvoResult?.success) {

                    this.$showError(
                        rvoResult?.message ||
                        this.$t("errors.RVO_sync_failed")
                    );

                    return;
                }

                // RVO successful - now rollback death
                const response = await axios.post(
                    `/Death/rollback/${id}`
                );

                if (response?.data?.success) {

                    this.$showSuccess(
                        this.$t(
                            'errors.Success_record_is_rollback_successfully'
                        )
                    );

                    await this.loadDeaths();

                } else {

                    this.$showError(
                        response?.data?.message ||
                        this.$t('errors.Contact_system_admin')
                    );
                }

            } catch (e) {

                // Don't show cancellation as an error
                if (axios.isCancel(e)) {
                    console.log('RVO sync cancelled');
                    return;
                }

                console.error('Rollback error:', e);

                const errorMessage =
                    e.response?.data?.message ||
                    e.message ||
                    this.$t('errors.Something_went_wrong');

                this.$showError(
                    `${this.$t('errors.Contact_system_admin')}: ${errorMessage}`
                );

            } finally {

                this.$store.commit(
                    'rvoSync/STOP_SYNC'
                );

                this.$store.commit(
                    'setShowLoading',
                    false
                );
            }
        },
        async syncRvo(
            id,
            animalUbn,
            departureToAnimalUbn,
            animalTagNumber,
            animalId,
            departureFromKeeperRVORelationNumber,
            departureToKeeperRVORelationNumber,
            cancelSource) {

            const payload = {                
                movementId: id,
                animalUbn: animalUbn,
                departureToAnimalUbn: departureToAnimalUbn,
                animalTagNumber: animalTagNumber,
                animalId: animalId,
                departureFromKeeperRVORelationNumber: departureFromKeeperRVORelationNumber,
                departureToKeeperRVORelationNumber: departureToKeeperRVORelationNumber
            };
            
            const response = await axios.post(
                "/rvo/syncrvocheckanimal",
                payload,
                {
                    cancelToken: cancelSource.token
                }
            );

            if (!response?.data?.success) {
                throw new Error(
                    response?.data?.message ||
                    this.$t("errors.RVO_sync_failed")
                );
            }

            return response.data;
        },
        formatDate(dateStr) {
            if (!dateStr) return '';
            const [year, month, day] = dateStr.split('-');
            return `${day}-${month}-${year}`;
        },
        deleteGroup(groupGuid) {
            if (!groupGuid) {
                this.$showError('errors.Group_id_is_missing');
                return;
            }

            this.$swal
                .fire({
                    text: this.$t('common.Are_you_sure_to_delete_this_group'),
                    //icon: "error",
                    cancelButtonText: this.$t('common.Cancel'),
                    confirmButtonText: this.$t('common.Confirm_Delete'),
                    showCancelButton: true,
                    position: 'top-end'
                })
                .then(async (result) => {
                    if (result["isConfirmed"]) {                        
                        try {
                            
                            this.$store.commit('setShowLoading', true);

                            const response = await axios.delete(`Death/group/${groupGuid}`);
                            this.gets = response.data;

                            if (this.gets.success) {
                                try {

                                    this.$showSuccess('errors.Success_death_group_deleted_successfully');
                                    await this.loadDeaths();
                                    
                                } catch (e) {
                                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                                    this.$showError(`${'errors.Contact_system_admin'}: ${errorMessage}`);
                                }
                            } else {
                                this.$showError('errors.Contact_system_admin');
                            }
                        } catch (e) {
                            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                            this.$showError(`${'errors.Contact_system_admin'}: ${errorMessage}`);
                        } finally {
                            this.$store.commit('setShowLoading', false);
                        }
                    }
                }); 
        },
        async fetchAllAssociationData() {
            try {
                const response = await axios.get("association/getall");
                const result = response.data;

                if (result.success && Array.isArray(result.data.associationList)) {
                    this.associations = result.data.associationList;
                } else {
                    this.$showError('errors.Error_fetching_associations');
                }
            } catch (e) {                    
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${'errors.Contact_system_admin'}: ${errorMessage}`);
            }
        },        
        async deleteDeathModal(id) {   
            this.$swal
                .fire({
                    text: this.$t('common.Are_you_sure_to_delete_this_record'),
                    //icon: "error",
                    cancelButtonText: this.$t('common.Cancel'),
                    confirmButtonText: this.$t('common.Confirm_Delete'),
                    showCancelButton: true,
                    position: 'top-end'
                })
                .then(async (result) => {
                    if (result["isConfirmed"]) {
                        try {
                            
                            this.$store.commit('setShowLoading', true);

                            const response = await axios.delete("Death/" + id);
                            this.gets = response.data;

                            if (this.gets.success) {
                                try {
                                    const fetchResponse = await axios.get("Death/getall");
                                    const fetchResult = fetchResponse.data;

                                    if (fetchResult.success) {

                                        this.deaths = fetchResult.data;

                                        await nextTick();
                                        this.initDataTable();
                                        console.log('here');
                                        //if (this.dataTableInstance && typeof this.dataTableInstance.rows === 'function') {                                            
                                        //    this.dataTableInstance.rows().remove();                                            
                                        //} else {
                                        //    console.log('DataTable instance is not valid or not initialized');
                                        //}

                                        this.$showSuccess('errors.Success_record_is_deleted_successfully');                                        
                                    } else {
                                        throw new Error('Failed to fetch updated animal list.');
                                    }
                                } catch (e) {
                                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                                    this.$showError(`${'errors.Contact_system_admin'}: ${errorMessage}`);
                                }
                            } else {                                    
                                this.$showError('errors.Contact_system_admin');
                            }                            
                        } catch (e) {
                            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                            this.$showError(`${'errors.Contact_system_admin'}: ${errorMessage}`);
                        } finally {
                            this.$store.commit('setShowLoading', false);
                        }
                    }
                });            
        }
    },
    computed: {
        groupedDeaths() {
            const groups = {};

            this.deaths.forEach(item => {
                let key = item.movementGroupId;
                
                if (!key || typeof key !== 'string' || !key.trim()) {
                    key = 'ungrouped';
                } else {
                    key = key.trim().toLowerCase();
                }

                if (!groups[key]) {
                    groups[key] = [];
                }

                groups[key].push(item);
            });

            return Object.values(groups); // Array of arrays
        },
        userRoleName() {
            return this.$store.state.user?.roleName;
        }
    }
}
</script>
<style scoped>
    ::v-deep .choices {
        width: auto !important;
        min-width: 270px;
    }

    .custom-association-dropdown {        
        border: 1px solid #4ca750;
    }

    /* Ensure the top container uses flex layout */
    ::v-deep .dataTable-top {
        display: flex !important;
        justify-content: flex-start !important;
        align-items: center !important;
    }

    /* Specifically target the search box to stay left aligned */
    ::v-deep .dataTable-top .dataTable-search {
        margin-right: auto !important;
        width: 50% !important;
    }

    ::v-deep .dataTable-top .dataTable-search .dataTable-input {
        width: 100% !important;
    }

    ::v-deep .dataTable-wrapper .dataTable-top .dataTable-search input {
        border: 1px solid #d2d2d2 !important;
    }

    /* Adjust the dropdown positioning (if present) */
    ::v-deep .dataTable-top .dataTable-dropdown {
        margin-left: 10px !important;
    }
</style>